import * as React from "react"
import { Flowbite } from "flowbite-react"

import CustomFooter from "./organisms/footer"
import { theme } from "../styles/flowbite-theme"

// Renders the B2B (Tailwind/Flowbite) footer for consumer pages.
// The `.tw-scope` wrapper is required because consumer pages render inside
// `static-layout`'s `.scss-scope`, so Tailwind utilities (which are scoped
// under `.tw-scope` via `important` in tailwind.config.js) would otherwise
// not apply. The `<Flowbite>` provider supplies the brand theme to
// flowbite-react components used inside the footer.
const TailwindFooter = () => (
  <div className="tw-scope">
    <Flowbite theme={{ theme: theme }}>
      <CustomFooter />
    </Flowbite>
  </div>
)

export default TailwindFooter
